import {
  SET_LANGUAGE_COLUMNS,
  SET_LANGUAGE_COLUMN,
  SET_DEFAULT_LANGUAGE_COLUMNS,
  RESET_COLUMN
} from "../actionTypes/wordListUi";
import {LANGUAGE_OPTIONS} from "../misc/config";

const initialLanguageState = {
  "visible": true,
  "order": 0
}

const initialVisibleLanguageList = ['ja_jp', 'en_us']

export function getInitialState() {
  let state = {
    updated: 0,
    columns: {}
  }
  LANGUAGE_OPTIONS.forEach(lang => {
    state.columns[lang.key] = {
      ...initialLanguageState,
      visible: initialVisibleLanguageList.includes(lang.key)
    };
  })
  return state
}

export default function (state = getInitialState(), action) {
  switch (action.type) {
    case SET_LANGUAGE_COLUMNS:
      return setLanguageColumns(state, action);
    case SET_LANGUAGE_COLUMN:
      return setLanguageColumn(state, action);
    case SET_DEFAULT_LANGUAGE_COLUMNS:
      return {};
    case RESET_COLUMN:
      return resetColmun(state, action);
    default:
      return state;
  }
}

const setLanguageColumns = (state, action) => {
  const {
    wordlistKey,
    columns
  } = action.payload;
  let newState = {
    ...state
  }
  newState[wordlistKey] = {
    ...state[wordlistKey] || getInitialState(),
    columns: columns || getInitialState().columns,
    updated: Date.now()
  };
  return newState
}

const setLanguageColumn = (state, action) => {
  const {
    wordlistKey,
    languageKey,
    column
  } = action.payload;
  let newState = {
    ...state
  }
  newState[wordlistKey] = {
    ...state[wordlistKey] || getInitialState(),
    updated: Date.now()
  };
  newState[wordlistKey].columns = {
    ...state[wordlistKey].columns,
    [languageKey]: column || {...initialLanguageState}
  }
  return newState
}

const resetColmun = (state, action) => {
  const { wordlistKey } = action.payload;
  const { [wordlistKey]: _, ...newState } = state;
  return newState
}